<!-- Hero Section (Full Width) -->
<div class="position-relative w-100 overflow-hidden">
  <div>
    <div class="position-relative w-100 overflow-hidden">
      <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>
      <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/B1PbI2vG5UyBZz6KBDrFFxYfBtnqqWRQLrFonIDK.jpg"
        alt="Virsa smart classroom interactive flat panel" class="img-fluid w-100" />
      <div
        class="hero-content position-absolute top-0 h-100 d-flex flex-column justify-content-center text-start pt-6 px-3 px-md-5">
        <div>
          <h1 class="headingBL title mb-3" style="font-size: 36px; margin-top: 4rem;">
            Next-Generation
            <br />Smart Classroom
            <br />Panel
          </h1>
          <div class="model-tabs mb-3">
            <button *ngFor="let size of modelSizes" [class.active]="selectedModel === size" (click)="selectModel(size)"
              class="model-tab">
              {{ size }}
            </button>
          </div>
          <!-- <div class="w-100 d-flex flex-row">
            <p class="text-white fs-6 fs-md-5 w-25 vtext w-md-50">
              Engage students with rich K–12 content, smart annotation tools,
              and ultra-responsive touch technology.
            </p>
          </div> -->
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Key Features Section -->
<section class="icon-features-section">
  <div class="container mb-5">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">Key <span>Features</span></h2>
      <div class="title-underline"></div>
    </div>
    <div class="icon-features-grid">
      <div class="feature-item" *ngFor="let feature of iconFeatures">
        <div class="icon-box">
          <mat-icon>{{ feature.icon }}</mat-icon>
          <div class="icon-bg"></div>
        </div>
        <h4 class="feature-title">{{ feature.title }}</h4>
        <p class="feature-desc">{{ feature.description }}</p>
      </div>
    </div>
  </div>
</section>

<!-- Table List -->
<div class="specifications-section">
  <div class="container mb-5">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">Technical <span>Specifications</span></h2>
      <div class="title-underline"></div>
    </div>
    <mat-tab-group dynamicHeight>
      <mat-tab *ngFor="let section of specSections" [label]="section.label">
        <div class="spec-table-wrapper mt-4">
          <app-spec-table [headerLabel]="section.headerLabel" [columns]="section.columns" [rows]="section.rows">
          </app-spec-table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>


<!-- Add-Ons Section -->
<section class="add-ons-section">
  <div class="container mb-5">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">Add-Ons</h2>
      <div class="title-underline"></div>
    </div>
    <div class="add-ons-grid">
      <div class="add-on-item" *ngFor="let item of addOns">
        <div class="icon-box">
          <mat-icon>{{ item.icon }}</mat-icon>
          <div class="icon-bg"></div>
        </div>
        <h4 class="add-on-item-title">{{ item.title }}</h4>
        <p class="add-on-item-desc">{{ item.description }}</p>
      </div>
    </div>
  </div>
</section>

<!-- Accessories Section -->
<section class="accessories-section">
  <div class="container mb-5">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">Accessories</h2>
      <div class="title-underline"></div>
    </div>
    <div class="accessories-grid">
      <div class="accessory-item" *ngFor="let item of accessories">
        <div class="icon-box">
          <mat-icon>{{ item.icon }}</mat-icon>
          <div class="icon-bg"></div>
        </div>
        <h4 class="accessory-title">{{ item.title }}</h4>
        <p class="accessory-desc">{{ item.description }}</p>
      </div>
    </div>
  </div>
</section>

<!-- Gallery Section -->
<section class="gallery-section">
  <div class="container mb-5">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">Gallery</h2>
      <div class="title-underline"></div>
    </div>
    <div class="gallery-grid">
      <div class="gallery-item" *ngFor="let image of galleryImages" (click)="openImageModal(image)">
        <div class="img-wrapper">
          <img [src]="image" alt="Virsa digital classroom solution installation" loading="lazy">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section text-center">
  <div class="container mb-5 cta-buttons">
    <a routerLink="/form/contactUs" class="btn-cta btn-cta-primary">
      <mat-icon>calendar_today</mat-icon>
      Schedule a Demo
    </a>
    <a href="/assets/pdf/Virsa-Panel-Brochure.pdf" target="_blank" class="btn-cta btn-cta-secondary">
      <mat-icon>download</mat-icon>
      Download Specs
    </a>
    <a routerLink="/form/contactUs" class="btn-cta btn-cta-secondary">
      <mat-icon>request_quote</mat-icon>
      Inquire
    </a>
  </div>

  <!-- Image Modal -->
  <div class="image-modal" *ngIf="selectedImage">
    <div class="modal-backdrop" (click)="closeImageModal()"></div>
    <div class="custom-modal-content">
      <button class="close-btn" (click)="closeImageModal()">
        <mat-icon>close</mat-icon>
      </button>
      <img [src]="selectedImage" alt="Virsa Digital Board">
    </div>
  </div>

  <!-- Centered Content End -->